import { useSSRHook } from "ssr-hook";
import { useHead } from "../services/common";
import { Project } from "../../types";
import Icon from "@mdi/react";
import { mdiCalendarMonth, mdiChevronDoubleRight, mdiFloppy, mdiPen, mdiPencil, mdiPlus } from "@mdi/js";
import { InputDate, Loading, Remove } from "../components";
import { useUser } from "../User";
import moment from "moment";
import { useState } from "react";
import { useRouter } from "easy-page-router/react";
import { api } from "../services/api";
import Content from "../components/Content";
import { ProjectYearList } from "./Projects";

export default function Project({ id }: { id: string }) {
    const { push } = useRouter();

    const user = useUser();

    const [project, error, isLoading, reload] = useSSRHook<Project>(`/api/project?projectId=${id}`);

    useHead({
        title: project ? `${project.title} | T.J. Sokol Poniklá` : "Projekt | T.J. Sokol Poniklá",
        description: project ? `${project.title} | T.J. Sokol Poniklá` : "Projekt | T.J. Sokol Poniklá",
    });

    const [edit, setEdit] = useState<null | { title: string, date: string }>(null);

    function handleEdit() {
        if (!project) return;

        setEdit({
            title: project.title,
            date: project.date,
        });
    }
    async function handleSave() {
        if (!edit || !project) return;

        const [_, error] = await api.updateProject({
            _id: project._id,
            title: edit.title,
            date: edit.date,
        });

        if (!error) {
            setEdit(null);
            reload();
        } else {
            // TODO: error
        }
    }
    async function handleRemove() {
        if (!project) return;

        const [, error] = await api.removeProject({ projectId: project._id });

        if (!error) {
            push("/projekty");
        } else {
            // TODO: error
        }
    }

    return <>
        <div className="header">
            <div className="h1">Projekty</div>
        </div>
        <section className="width-max page-split project-page">
            <div>
                {user.isAdmin && <div className="admin">
                    {!edit && <button onClick={handleEdit}><Icon path={mdiPencil} size={1} /> Upravit nadpis a datum</button>}
                    {!edit && <Remove onRemove={handleRemove} >Odstranit projekt</Remove>}
                    {edit && <button onClick={handleSave}><Icon path={mdiFloppy} size={1} /> Uložit změny v nadpisu</button>}
                </div>}

                {isLoading && <Loading />}
                {error && <p className="alert">Projekty se nepodařilo načíst. Zkuste to prosím později.</p>}
                {project && <>
                    {!edit && <>
                        <h1>{project.title}</h1>
                        <div className="date"><Icon path={mdiCalendarMonth} size={0.8} />{moment(project.date).format("LL")}</div>
                    </>}
                    {edit && <>
                        <input type="text" className="h1" value={edit.title} onChange={e => setEdit({ ...edit, title: e.target.value })} />
                        <InputDate value={edit.date} onChange={date => setEdit({ ...edit, date })} />
                    </>}

                    <Content id={project.contentId} />
                </>}
            </div>
            <ProjectYearList
                year={project ? moment(project.date).format("YYYY") : moment().format("YYYY")}
                onChange={year => push(`/projekty?year=${year}`)}
            />
        </section>
    </>;
}
